export default __webpack_public_path__ + "static/media/blue_logout.2d13e9b9.svg";